/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Choose_Folder_ButtonInputs */



/**
* | output |
* | --- |
* | "Choose Folder" |
*
* @param {Image_Export_Choose_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_choose_folder_button = /** @type {((inputs?: Image_Export_Choose_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Choose_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elegir carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फोल्डर को चुनो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a pasta")
	return /** @type {LocalizedString} */ ("Choose Folder")
});